import service from "@/api/axios";
import { LoginRequest, RegistrationRequest} from "@/interface/auth";
import { PasswordRequest } from "@/interface/auth";
import { USER_URL, LOG_IN_URL, TOKEN_REFRESH_URL, PASSWORD_URL} from "@/constants/urls";

export const login = (data: LoginRequest) => service.post(LOG_IN_URL, data);

export const password = (data: PasswordRequest) =>
  service.post(PASSWORD_URL, data);

export const refreshToken = (refresh: string) =>
  service.post(TOKEN_REFRESH_URL, {
    refresh,
  });

export const getUser = () => service.get(USER_URL);

export const createUser = (data: RegistrationRequest) =>
  service.post(USER_URL, data);
